import makeInitialState from './makeInitialState'
import orderBy from 'lodash/orderBy'

export function loadProjectSuccess(state, project) {
    state.project = project
}

export function updateRelativeTime(state, { clipId, relativeTime }) {
    if (state.playingClipId == clipId) {
        state.relativeTime = relativeTime
    }
}

export function jumpToAbsoluteTime(state, absoluteTime) {
    const { clip, relativeTime } = getClipByTime(state, absoluteTime)

    state.playingClipId = clip.id
    state.relativeTime = relativeTime
    state.relativeTimeSetting = makeTimeRequest(relativeTime)
}

export function jumpToClip(state, clipId) {
    state.playingClipId = clipId
    state.relativeTime = 0
    state.relativeTimeSetting = makeTimeRequest(0)
}

// Originally, state.relativeTimeSetting was just an integer.
// But we want to know when it gets set and then set again later,
// even if it's set to the same integer -
// it means we re-requested the same time we requested earlier,
// which the player may have moved on from.
// To make sure that changes get picked up, we just wrap it in an object
// so it's always a different object and triggers watchers.
const makeTimeRequest = time => ({ time })

export function paused(state) {
    state.isPaused = true
}

export function resumed(state) {
    state.isPaused = false
    state.hasEverPlayed = true
}

export function reset(state) {
    const newState = makeInitialState()

    Object.keys(newState).forEach(key => state[key] = newState[key])
}

export function setFullScreen(state, fullScreen) {
    state.isFullScreen = fullScreen
}

export function setVolume(state, volume) {
    state.volume = volume
}

export function muted(state) {
    state.isMuted = true
}

export function unmuted(state) {
    state.isMuted = false
}

export function expandedAllClips(state) {
    state.expandedAllClips = true
}

export function unexpandedAllClips(state) {
    state.expandedAllClips = false
}

function getClipByTime(state, absoluteTime) {
    let total = 0

    const orderedClips = orderBy(state.project.clips, 'order', 'asc')

    for (const clip of orderedClips) {
        const startTime = clip.start_time || 0
        const endTime = clip.end_time || clip.video.duration
        const duration = endTime - startTime

        if (total + duration >= absoluteTime) {
            return { clip, relativeTime: absoluteTime - total }
        }

        total += duration
    }

    return null
}
